<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/logbook/index">Logbook</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        View Logbook Entry
      </h6>

      <div style="padding-bottom: 100px" class="container-fluid">
        <div class="card custom_bdr_rds shadow p-2 mb-4">
          <div class="card-body custom_bdr_rds">
            <div class="d-flex justify-content-between align-items-center flex-wrap">
              <h6 class="purchitem mb-2"><b>Logbook Details</b></h6>
              <router-link :to="'/logbook/create?id=' + id" class="btn btn-primary bdr-rad font-size_def mt-2 mt-md-0">
                Edit
              </router-link>
            </div>

            <table style="font-size: small;" class="table table-sm table-borderless mb-0">
              <tbody>
                <tr>
                  <td class="width-custom2"><b>Date</b></td>
                  <td>{{ header.date || "-" }}</td>
                  <td><b>Vessel / Activities</b></td>
                  <td>{{ header.vessel || "-" }}</td>
                </tr>
                <tr>
                  <td><b>Vessel Class</b></td>
                  <td>{{ header.vessel_class || "-" }}</td>
                  <td><b>W/F</b></td>
                  <td>{{ header.wf || "-" }}</td>
                </tr>
                <tr>
                  <td><b>Total Entries</b></td>
                  <td>{{ details.length }}</td>
                  <td><b>Total Hours</b></td>
                  <td>{{ totalSavedHours }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card custom_bdr_rds shadow p-2">
          <div class="card-body custom_bdr_rds">
            <h6 class="purchitem mb-2"><b>Saved Entries</b></h6>

            <div class="table-responsive">
              <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                <thead class="background_color2">
                  <tr class="custom-label2">
                    <th>#</th>
                    <th>Type</th>
                    <th>Crew</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Code Name</th>
                    <th class="text_right">Durations</th>
                    <th class="text_right">Numbers of Connection</th>
                    <th class="text_right">Durations BKR</th>
                    <th class="text_right">Total Man/Hrs</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in details" :key="row.id || index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ formatServiceType(row.service_type) }}</td>
                    <td>{{ row.num_crew || "-" }}</td>
                    <td>{{ formatDateTime(row.start_time) }}</td>
                    <td>{{ formatDateTime(row.end_time) }}</td>
                    <td>
                      <div
                        v-for="(item, itemIndex) in buildCodeDurationRows(row)"
                        :key="'code-' + index + '-' + itemIndex"
                        class="saved-entry-line"
                      >
                        {{ item.code }}
                      </div>
                    </td>
                    <td class="text_right">
                      <div
                        v-for="(item, itemIndex) in buildCodeDurationRows(row)"
                        :key="'duration-' + index + '-' + itemIndex"
                        class="saved-entry-line"
                      >
                        {{ item.duration }}
                      </div>
                    </td>
                    <td class="text_right">{{ row.nos_of_con || "-" }}</td>
                    <td class="text_right">{{ row.dur_bkr || "-" }}</td>
                    <td class="text_right">{{ row.tm_hrs_vessel || "-" }}</td>
                  </tr>
                  <tr v-if="!loading && !details.length">
                    <td colspan="10" class="text-center text-muted">No service entries found.</td>
                  </tr>
                </tbody>
                <tfoot style="border-top: 1px black solid;">
                  <tr >
                    <td colspan="5"></td>
                    <td><b>Total</b></td>
                    <td class="text_right"><b>{{ totalSavedHours }}</b></td>
                    <td></td>
                    <td></td>
                    <td class="text_right"><b>{{ totalSavedManHours }}</b></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div v-if="loading" class="text-muted mt-2">Loading...</div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

const SERVICE_OPTIONS = [
  { label: "Mooring", value: "mooring" },
  { label: "Connection", value: "connection" },
  { label: "Disconnect", value: "disconnect" },
  { label: "Unmooring", value: "unmooring" },
  { label: "Other", value: "other" },
  { label: "Ship Shore Check", value: "ship_shore_check" },
  { label: "Housekeeping", value: "housekeeping" },
  { label: "Maintenance", value: "maintenance" },
];

export default {
  components: {
    ContentFooter,
    TopNavbar,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      id: this.$route.query.id || null,
      loading: false,
      header: {},
      details: [],
      memberCodeOptions: [],
      serviceOptions: SERVICE_OPTIONS,
    };
  },

  computed: {
    totalSavedHours() {
      const total = this.details.reduce((sum, row) => sum + this.savedRowHoursValue(row), 0);
      return total ? total.toFixed(2).replace(/\.00$/, "") : "0";
    },

    totalSavedManHours() {
      const total = this.details.reduce((sum, row) => {
        return sum + this.parseDurationValue(row.tm_hrs_vessel);
      }, 0);

      return total ? total.toFixed(2).replace(/\.00$/, "") : "0";
    },
  },

  mounted() {
    this.loadMemberCodeOptions();
    this.loadLogbook();
  },

  methods: {
    async loadMemberCodeOptions() {
      try {
        const response = await axios.get("/logbook/membercodelist", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-Type": "application/json",
          },
        });

        if (response.data.status === 200) {
          this.memberCodeOptions = response.data.data || [];
        }
      } catch (error) {
        console.error(error.response || error);
      }
    },

    parseDurationValue(value) {
      if (value === "" || value === null || value === undefined) {
        return 0;
      }

      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    },

    savedRowHoursValue(row) {
      if (row.tm_hrs_vessel !== "" && row.tm_hrs_vessel !== null && row.tm_hrs_vessel !== undefined) {
        return this.parseDurationValue(row.tm_hrs_vessel);
      }

      if (row.total_duration !== "" && row.total_duration !== null && row.total_duration !== undefined) {
        return this.parseDurationValue(row.total_duration);
      }

      return 0;
    },

    formatDateTime(value) {
      return value ? value.replace("T", " ") : "-";
    },

    formatServiceType(value) {
      const found = this.serviceOptions.find((item) => item.value === value);
      return found ? found.label : value;
    },

    resolveMemberCodeLabel(value) {
      if (!value) {
        return "-";
      }

      const normalizedValue = String(value);
      const found = this.memberCodeOptions.find(
        (item) =>
          String(item.id) === normalizedValue ||
          item.name === value ||
          item.label === value
      );

      return found ? found.label : value;
    },

    buildCodeDurationRows(row) {
      const hasComponentDuration = [row.dur_c1, row.dur_c2, row.dur_c3, row.dur_c4].some(
        (value) => value !== "" && value !== null && value !== undefined
      );

      const items = [
        { code: row.code_name_1, duration: row.dur_c1 },
        { code: row.code_name_2, duration: row.dur_c2 },
        { code: row.code_name_3, duration: row.dur_c3 },
        { code: row.code_name_4, duration: row.dur_c4 },
      ]
        .map((item, index) => ({
          code: item.code || "-",
          duration:
            item.duration ||
            (!hasComponentDuration && index === 0 && row.total_duration ? row.total_duration : ""),
        }))
        .filter((item) => item.duration !== "" && item.duration !== null && item.duration !== undefined);

      if (items.length) {
        return items.map((item) => ({
          code: this.resolveMemberCodeLabel(item.code),
          duration: item.duration || "-",
        }));
      }

      if (row.total_duration) {
        return [
          {
            code: this.resolveMemberCodeLabel(row.code_name_1),
            duration: row.total_duration || "-",
          },
        ];
      }

      return [{ code: "-", duration: "-" }];
    },

    async loadLogbook() {
      if (!this.id) {
        return;
      }

      this.loading = true;

      try {
        const { data } = await axios.get("/logbook/loadvessel?id=" + this.id, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200) {
          this.header = data.data || {};
          this.details = data.details || [];
        }
      } catch (error) {
        console.error(error.response || error);
        alert("Error loading logbook entry.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.saved-entry-line + .saved-entry-line {
  margin-top: 4px;
}
</style>
